/**
 * Sprint 18 B4: Portal Messages — buyer-provider messaging
 */
import { useState } from "react";
import { Send } from "lucide-react";

export default function PortalMessages() {
  const [message, setMessage] = useState("");

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-[var(--color-foreground)]">Messages</h1>

      <div className="rounded-xl border border-[var(--color-border)] bg-[var(--color-background)] overflow-hidden" style={{ height: "500px" }}>
        {/* Message area */}
        <div className="flex-1 p-6 overflow-y-auto" style={{ height: "430px" }}>
          <div className="flex flex-col items-center justify-center h-full text-[var(--color-muted-foreground)]">
            <p className="text-sm">No messages yet. Send a message to your provider.</p>
          </div>
        </div>

        {/* Input */}
        <div className="border-t border-[var(--color-border)] p-3 flex gap-2">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
            className="flex-1 rounded-lg border border-[var(--color-border)] bg-[var(--color-background)] px-4 py-2 text-sm text-[var(--color-foreground)]"
          />
          <button
            type="button"
            disabled={!message.trim()}
            className="rounded-lg bg-[var(--color-primary)] px-4 py-2 text-white disabled:opacity-50"
          >
            <Send className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
